import React, { useEffect, useState } from "react";
import { couponType, getFromLocalStorage } from "../../../helpers";
import { useDispatch, useSelector } from "react-redux";
import CartItem from "../CartItem";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getSystemCharges } from "../../../api/user/settings";
import AllItemsDiscountModal from "../../modal/AllItemsDiscountModal";
import AddressDetails from "./AddressDetails";
import Optional from "./Optional";
import ApplyCouponModal from "../../modal/ApplyCouponModal";
import { isDisabled } from "../../../reducers/common";
import { items_coupon_discount } from "../../../api/user/order";
import { getUserRewards } from "../../../api/common";
import ItemsDiscountModal from "../../modal/ItemsDiscountModal";
import OrderSummary from "./OrderSummary";
import CheckoutSummary from "./CheckoutSummary";

const OrderDetails = ({
  cart,
  placeOrderHandler,
  setPaymentTypeHandler,
  orderDetail,
  changeAddressHandler,
  setOrderInstraction,
  orderInstraction,
  setDiscountData,
  dicountData,
}) => {
  const dispatch = useDispatch();
  const param = useParams();

  let userInfo = getFromLocalStorage("userInfo");

  const { userRewards } = useSelector((state) => state.common);
  const { total_amount } = useSelector((state) => state.cart);
  const addressObj = useSelector((state) => state.order.address);
  const [paymentType, setPaymentType] = useState();
  const [couponCode, setCouponCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [shippingCharge, setShippingCharge] = useState(0);
  const [visible, setVisible] = useState(false);
  const [popUpVisible, setPopUpVisible] = useState(false);
  const [discountPopUpVisible, setDiscountPopUpVisible] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [step, setStep] = useState(false);
  const [eligibleDiscount, setEligibleDiscount] = useState("");
  const [orderSummary, setOrderSumarry] = useState({
    subTotal: total_amount,
    rewards: 0,
    shippingCharges: 0,
    discount: 0,
    couponDiscountType: "",
    discountType: "",
    discountName: "",
  });

  const totalItems = cart?.reduce(
    (accumulator, currentValue) => accumulator + currentValue?.amount,
    0
  );

  useEffect(() => {
    dispatch(getSystemCharges())
      .then((res) => {
        if (res.statusCode === 200) {
          setShippingCharge(res?.data?.shippingCharge);
          setOrderSumarry({
            ...orderSummary,
            shippingCharges: Number(res?.data?.shippingCharge),
          });
        }
      })
      .catch((err) => {
        toast.error(err.returnMessage[0]);
      });

    dispatch(getUserRewards({ userId: userInfo?.data?.userId }))
      // .then((res) => {})
      .catch((err) => console.error(err.returnMessage[0]));
  }, []);

  const orderHandler = () => {
    if (localStorage.address === undefined && !addressObj?.id) {
      toast.warn("Please Select Address First!");
      return false;
    }
    if (!paymentType) {
      toast.warn("Please Select Payment Type First!");
      return false;
    }
    if (paymentType && (localStorage.address || addressObj?.id)) {
      placeOrderHandler();
    }
  };

  const stepHandler = () => {
    setLoading(true)
    dispatch(
      items_coupon_discount({ couponCode: "", numberofItems: totalItems })
    )
      .then((res) => {
        if (res.statusCode === 200 && res?.data?.discountResponse?.isValid) {
          setLoading(false)
          setEligibleDiscount(res?.data);
          setDiscountPopUpVisible(true);
          setStep(true);
          dispatch(isDisabled(true));
          setCouponCode("");
          setIsShow(true);
          setOrderSumarry({
            ...orderSummary,
            discount: Number(
              res?.data?.discountResponse?.discountPerItem * totalItems
            ),
            discountName: "items",
          });
          setDiscountData({ ...dicountData, discountApplied: 2 });
        }
        if (
          res.statusCode === 200 &&
          res?.data?.discountResponse?.isValid === false
        ) {
          setLoading(false)
          setStep(true);
          dispatch(isDisabled(true));
          setCouponCode("");
          setOrderSumarry({
            ...orderSummary,
            discount: 0,
          });
          setEligibleDiscount("");
        }
      })
      .catch((err) => {
        toast.error(err.returnMessage[0]);
        setLoading(false)
      });
  };

  const couponHandler = () => {
    if (!couponCode) {
      toast.warn("Please fill the code before applying!");
      return true;
    }

    dispatch(
      items_coupon_discount({
        couponCode: couponCode,
        numberofItems: totalItems,
      })
    )
      .then((res) => {
        if (
          res.statusCode === 200 &&
          res?.data?.couponResponse?.isValid === false
        ) {
          toast.error(res?.data?.couponResponse?.message);
        }
        if (
          res.statusCode === 200 &&
          res?.data?.couponResponse?.isValid &&
          res?.data?.discountResponse?.isValid
        ) {
          setPopUpVisible(true);
        }
        if (
          res.statusCode === 200 &&
          res?.data?.couponResponse?.isValid &&
          res?.data?.discountResponse?.isValid === false
        ) {
          if (res?.data?.couponResponse?.type === couponType?.Percentage) {
            const discountAmount =
              (total_amount * res?.data?.couponResponse?.amount) / 100;
            setOrderSumarry({
              ...orderSummary,
              discount: Number(discountAmount),
              discountType: "coupon",
              couponDiscountType: "Percentage",
            });
            setDiscountData({
              ...dicountData,
              couponCode: couponCode,
              discountApplied: 1,
            });
            setIsShow(true);
            toast.success("Coupon Applied Successfully.");
          }
          if (res?.data?.couponResponse?.type === couponType?.Fixed) {
            if (total_amount >= res?.data?.couponResponse?.amount) {
              setOrderSumarry({
                ...orderSummary,
                discount: Number(res?.data?.couponResponse?.amount),
                discountType: "coupon",
                couponDiscountType: "Fixed",
              });
              setDiscountData({
                ...dicountData,
                couponCode: couponCode,
                discountApplied: 1,
              });
              setIsShow(true);
              toast.success("Coupon Applied Successfully.");
            } else {
              toast.warn(
                `Your Coupon discount ($${res?.data?.couponResponse?.amount}) is greater then subtotal, Please add more items.`
              );
            }
          }
        }
      })
      .catch((err) => {
        toast.error(err.returnMessage[0]);
      });
  };

  const deleteHandler = () => {
    setCouponCode("");
    if (eligibleDiscount?.discountResponse?.isValid) {
      setOrderSumarry({
        ...orderSummary,
        discount: Number(
          eligibleDiscount?.discountResponse?.discountPerItem * totalItems
        ),
        discountType: "",
        discountName: "items",
      });
      setDiscountData({ ...dicountData, couponCode: "", discountApplied: 2 });
    } else {
      setIsShow(false);
      setOrderSumarry({
        ...orderSummary,
        discountType: "",
        discountName: "items",
        discount: 0,
      });
      setDiscountData({ ...dicountData, couponCode: "", discountApplied: 0 });
    }
  };

  const rewardHandler = () => {
    if (total_amount < userRewards) {
      toast.warn(
        "Your reward amount is greater then subtotal, Please add more items."
      );
    } else {
      setDiscountData({
        ...dicountData,
        useRewardPoints: !dicountData?.useRewardPoints,
      });
    }
  };

  return (
    <>
      <div>
        <div className="row">
          <div className="col-sm-12 col-md-8 col-lg-9 mt-2">
            <div className="form-control table-responsive-md cartTotals table-responsive">
              <table className="table   ">
                <thead>
                  <tr className="">
                    <th className="py-2">Product</th>
                    <th className="py-2">Price</th>
                    <th className="py-2">Quantity</th>
                    <th className="py-2">Subtotal</th>
                    <th className="py-2"> </th>
                  </tr>
                </thead>
                <tbody>
                  {cart?.map((item) => {
                    return (
                      <CartItem
                        key={item.productId}
                        {...item}
                        param={param?.id}
                      />
                    );
                  })}
                </tbody>
              </table>
            </div>
            {!param?.id && (
              <>
                <div className="">
                  <AddressDetails changeAddressHandler={changeAddressHandler} />
                </div>
                <div>
                  <Optional
                    setOrderInstraction={setOrderInstraction}
                    orderInstraction={orderInstraction}
                  />
                </div>
              </>
            )}
          </div>

          <div className="col-sm-12 col-md-4 col-lg-3 mt-2">
            {param?.id ? (
              <OrderSummary
                orderDetail={orderDetail}
                shippingCharge={shippingCharge}
              />
            ) : (
              <>
                <CheckoutSummary
                  couponCode={couponCode}
                  orderDetail={orderDetail}
                  shippingCharge={shippingCharge}
                  orderHandler={orderHandler}
                  setVisible={setVisible}
                  stepHandler={stepHandler}
                  dicountData={dicountData}
                  paymentType={paymentType}
                  step={step}
                  setStep={setStep}
                  setIsShow={setIsShow}
                  isShow={isShow}
                  loading={loading}
                  orderSummary={orderSummary}
                  setOrderSumarry={setOrderSumarry}
                  setCouponCode={setCouponCode}
                  couponHandler={couponHandler}
                  deleteHandler={deleteHandler}
                  rewardHandler={rewardHandler}
                  setPaymentType={setPaymentType}
                  setPaymentTypeHandler={setPaymentTypeHandler}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <AllItemsDiscountModal
        visible={visible}
        header={"All Discounts"}
        setVisible={() => setVisible(false)}
        footer={false}
      />
      <ItemsDiscountModal
        visible={discountPopUpVisible}
        header={"Discount Applied"}
        setVisible={() => setDiscountPopUpVisible(false)}
        footer={false}
        eligibleDiscount={eligibleDiscount}
        totalItems={totalItems}
      />
      <ApplyCouponModal
        visible={popUpVisible}
        header={"All Eligible Discounts"}
        setVisible={() => setPopUpVisible(false)}
        footer={true}
        orderSummary={orderSummary}
        setCouponCode={setCouponCode}
        setOrderSumarry={setOrderSumarry}
        totalItems={totalItems}
        setIsShow={setIsShow}
        couponCode={couponCode}
        setDiscountData={setDiscountData}
        dicountData={dicountData}
      />
    </>
  );
};

export default OrderDetails;
